module.exports = __webpack_public_path__ + "img/formbgc.0f522f6d.png";